module.exports = __webpack_public_path__ + "img/miniprogram.756e655d.jpg";